import axios from 'axios'

import { normalizeError } from './utils'

const exclusionsService = () => {
  const fetchFiles = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/exclusions', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchFile = async (accessToken, fileName) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get(`/api/exclusions/${fileName}`, config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const addFile = async (accessToken, fileName, content) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.put(`/api/exclusions/${fileName}`, content, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const updateFile = async (accessToken, fileName, content) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/exclusions/${fileName}`, content, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const removeFile = async (accessToken, fileName) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.delete(`/api/exclusions/${fileName}`, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  return { fetchFiles, fetchFile, addFile, updateFile, removeFile }
}

export default exclusionsService()
